// Copyright (c) 2022 Alife Health - All Rights Reserved
import { RefObject, useEffect, useRef } from 'react';

export function usePrevious<T>(val: T): RefObject<T | undefined>['current'] {
  const ref = useRef<T>();

  useEffect(() => {
    ref.current = val;
  }, [val]);

  return ref.current;
}
